import providerSchedulingPage from './ProviderSchedulingPageWithData';

export default providerSchedulingPage;
